import React, { useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Modal, Box, Slide, Typography } from "@mui/material";
import PolarChart from "../../Layouts/Report/Assignments/PolarChart";

const PolarChartModal = (props) => {
    // Hooks
    const containerRef = useRef();
    const styles = useStyles();
    
    return (
        <Modal
            open={props.show}
            onClose={() => {
                props.toggleModal(false);
            }}
            ref={containerRef}
        >
            <Slide direction="up" in={props.show} container={containerRef.current}>
                <Grid container className={styles.Modal}>
                    <Grid item xs={12}>
                        <Box sx={{ backgroundColor: '#DB8829', borderTopLeftRadius: 30, borderTopRightRadius: 30, padding: 2 }}>
                            <Typography sx={{ fontSize: '1.2rem', fontWeight: 900 }}>
                                Skill Wise Report
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sx={{ padding: 1 }}>                        
                        <PolarChart
                            polarChartData={props.polarChartData}
                            fromModl={true}
                        />
                    </Grid>
                </Grid>
            </Slide>
        </Modal>

    );
};

const useStyles = makeStyles({
    Modal: {
        position: 'absolute',
        top: '13%',
        left: '25%',
        width: '55%',
        height: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#f4f4f4',
        boxShadow: 24,
        color: '#FFFFFF',
        borderRadius: 30
    }
});
export default PolarChartModal;
